import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { UnifiedAgentStore } from '../store/unifiedAgentStore'

const UnifiedAgentContext = createContext<UnifiedAgentStore | null>(null)

export const useUnifiedAgentContext = () => {
  const context = useContext(UnifiedAgentContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with UnifiedAgentProvider')

  return context
}

type IUnifiedAgentProviderProps = PropsWithChildren<{
  agentId: number | null
}>

export const UnifiedAgentProvider = ({ agentId, children }: IUnifiedAgentProviderProps) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new UnifiedAgentStore(agentId, entities), [])

  useEffect(() => store.dispose, [])

  return <UnifiedAgentContext.Provider value={store}>{children}</UnifiedAgentContext.Provider>
}
